import { ExportDataSearchOutput } from '../models/exports.model';

export class ExportsListLoad {
  public static readonly type = '[ExportsList] Load';

  constructor(public payload: ExportDataSearchOutput) {}
}

export class ExportsListDownloadFile {
  public static readonly type = '[ExportsList] Download File';

  constructor(public payload: string) {}
}

export class ExportsListInitialState {
  public static readonly type = '[ExportsList] Set Initial State';
}
